export const introText = [
  `GPU AUDIO™ is an international startup packed with CS Ph.D. engineers and Pro Audio industry professionals from over
  12 countries.`,
  `We built the world's first GPU-powered accelerated audio computing technology. GPU-based technology offers unlimited
  power & scalability to digital audio compared to CPU and other alternatives and we believe GPUs will democratize
  accelerated audio computing and power up future audio workflows.
  `,
  'The company is also venture-backed by various angel investors, VC professionals, and funds.',
]
